export default {
  IN_STORE: 'IN_STORE',
  CURB_SIDE: 'CURB_SIDE',
}



// WEBPACK FOOTER //
// ./src/constants/venueOrderPickUpTypes.js